function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI---Workspace-Dropdown",
  transform: "translate(-1227.000000, -142.000000)",
  fill: "#9399AC",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(869.000000, 61.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(1.000000, 60.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M371.4625,29 C371.4625,28.0041667 372.079167,27.2166667 373,26.675 C372.833333,26.1208333 372.6125,25.5833333 372.341667,25.0833333 C371.304167,25.3541667 370.466667,24.95 369.758333,24.2416667 C369.054167,23.5375 368.8375,22.6958333 369.108333,21.6583333 C368.608333,21.3875 368.075,21.1666667 367.516667,21 C366.975,21.925 366,22.5375 365,22.5375 C364.004167,22.5375 363.025,21.925 362.483333,21 C361.925,21.1666667 361.391667,21.3875 360.891667,21.6583333 C361.1625,22.6958333 360.945833,23.5333333 360.241667,24.2416667 C359.5375,24.9458333 358.695833,25.3541667 357.6625,25.0833333 C357.3875,25.5833333 357.166667,26.1166667 357,26.675 C357.925,27.2166667 358.541667,28.0041667 358.541667,29 C358.541667,29.9958333 357.925,30.975 357,31.5166667 C357.166667,32.075 357.3875,32.6083333 357.658333,33.1083333 C358.695833,32.8375 359.533333,33.0541667 360.2375,33.7583333 C360.945833,34.4625 361.158333,35.3041667 360.8875,36.3416667 C361.391667,36.6125 361.920833,36.8333333 362.479167,37 C363.020833,36.075 364,35.4625 364.995833,35.4625 C365.991667,35.4625 366.970833,36.075 367.5125,37 C368.070833,36.8333333 368.604167,36.6125 369.104167,36.3416667 C368.833333,35.3041667 369.05,34.4666667 369.754167,33.7583333 C370.458333,33.0541667 371.3,32.6458333 372.3375,32.9166667 C372.608333,32.4125 372.829167,31.8791667 372.995833,31.325 C372.075,30.7833333 371.4625,29.9958333 371.4625,29 Z M365,33 C362.794507,33 361,31.2095626 361,29 C361,26.7904374 362.790437,25 365,25 C367.209563,25 369,26.7904374 369,29 C369,31.2095626 367.209563,33 365,33 Z",
  id: "Shape"
})))));

var SvgGear = function SvgGear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Gear.17bec2ec.svg";
export { ForwardRef as ReactComponent };